import request from "@/services/axios";
import { url } from "@/services/api";
// const url = "http://192.168.88.140:15001"

export default {
  // 分页查询视图列表
  getChartsViewPage(params) {
    return request({
      url: url + "/system/view/list",
      method: "get",
      params: params
    });
  },
  // 视图下拉选择列表
  getChartsViewList(params) {
    return request({
      url: url + "/system/view/selectList",
      method: "get",
      params: params
    });
  },

  // 新增模型视图
  AddChartsView(data) {
    return request({
      url: url + "/system/view",
      method: "post",
      data: data
    });
  },
  // 修改模型视图
  UpdateChartsView(data) {
    return request({
      url: url + "/system/view",
      method: "post",
      data: data
    });
  },
  // 删除模型视图
  DelChartsView(data) {
    return request({
      url: url + "/system/view/" + data.id,
      method: "delete"
    });
  },
  // 获取模型视图详细信息
  getChartsViewInfo(params) {
    return request({
      url: url + "/system/view/" + params.id,
      method: "get"
    });
  },
  // 查询模型图形数据
  getChartData(params) {
    return request({
      url: url + "/system/view/getChartData/" + params.id,
      method: "get"
    });
  },

  // 执行SQL查询数据
  executeSql(data) {
    return request({
      url: url + "/system/view/executeSql",
      method: "post",
      data
    });
  },
  // 数据源信息选择列表
  getDataSourceList(params) {
    return request({
      url: url + "/system/dataSource/selectlist",
      method: "get",
      params
    });
  }
};
